import {
  valuableCardValue,
  standardPropertyTypesForDualPropertyCard,
} from '@kapitalist/contract/ruleset'
import type {
  TDualPropertyCardData,
  TStandardPropertyCard,
} from '@kapitalist/contract/types'
import type {TMillions} from '@kapitalist/contract/types/millions'
import type {NEList} from '@kapitalist/utils/NEList'
import {first} from '@kapitalist/utils/Set'
import type {TNeighborhood} from '~/game/types'
import SpecialPropertyCard from '~/models/game/Cards/SpecialPropertyCard'

export default class DualPropertyCard extends SpecialPropertyCard<TDualPropertyCardData> {
  public value: TMillions

  constructor(data: TDualPropertyCardData) {
    super(data)
    this.value = valuableCardValue[data.type]
  }

  // overriding Card function
  public isFlippable = (): boolean => true

  upsideDownForNeighborhood = (neighborhood: TNeighborhood): boolean => {
    return first(this.standardPropertyTypesSet()) !== neighborhood
  }

  standardPropertyTypesSet = (): Set<TStandardPropertyCard> => {
    return new Set(standardPropertyTypesForDualPropertyCard(this.type))
  }
  standardPropertyTypesNEList(): NEList<TStandardPropertyCard> {
    return standardPropertyTypesForDualPropertyCard(this.type)
  }
}
